import { Outlet } from "react-router-dom";
import TabelInfo from "./components/tabela/tabela";
import { EventsListProvider } from "./context/getListaPg";


export default function Info() {
  return (
    <EventsListProvider>
      <>
        <TabelInfo />
        <Outlet />
      </>
    </EventsListProvider>
  )
}
